import classNames from "classnames";
import { Card } from "components/ui/card";
import { Color } from "utils/theme";

interface BlockProps extends React.HTMLAttributes<HTMLDivElement> {
  value: string | number | JSX.Element;
  header?: string | number | JSX.Element;
  footer?: string | number | JSX.Element;
  valueColor?: string;
}

export const Block = ({
  value,
  header,
  footer,
  valueColor,
  className,
  ...props
}: BlockProps) => {
  return (
    <Card
      className={classNames(
        "px-3 py-2 flex flex-col items-center justify-center space-y-6 2xl:space-y-8",
        className
      )}
      {...props}
    >
      <div
        className="text-center font-medium leading-tight text-lg sm:text-xl lg:text-2xl"
        style={{ color: Color.Primary[400] }}
      >
        {header}
      </div>
      <div className="min-h-0 flex justify-center items-center py-1">
        <div
          className={`text-center font-medium tabular-nums font-mono leading-none text-4xl md:text-5xl lg:text-6xl 2xl:text-[6rem] ${
            valueColor ?? "text-gray-100"
          }`}
          style={{ color: valueColor ?? Color.White }}
        >
          {value}
        </div>
      </div>
      <div
        className="text-center font-medium leading-tight text-base sm:text-lg lg:text-xl min-h-7"
        style={{ color: Color.Primary[400] }}
      >
        {footer}
      </div>
    </Card>
  );
};
